// extracted by mini-css-extract-plugin
module.exports = {"item":"MenuItem_item__3Bc0F","active":"MenuItem_active__2Ketl"};